import { render, staticRenderFns } from "./studentroster.vue?vue&type=template&id=2585d91c&scoped=true"
import script from "./studentroster.vue?vue&type=script&lang=js"
export * from "./studentroster.vue?vue&type=script&lang=js"
import style0 from "./studentroster.vue?vue&type=style&index=0&id=2585d91c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585d91c",
  null
  
)

export default component.exports